// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Usa from '../_raw/flag/icon_flag_usa.png';

export default () => <img src={Usa} alt="Usa" />;
